const availableProfileTabs = [
  "newsfeed",
  "info",
  "groups",
  "notes",
  "documents",
  "giving",
  "wallet",
];

export default function moveProfileTabToFront(
  currentProfileTabs,
  tabToMoveToFront
) {
  let clone = [...(currentProfileTabs || [])];
  if (!availableProfileTabs.includes(tabToMoveToFront)) return clone;
  if (clone.includes(tabToMoveToFront)) {
    const index = clone.indexOf(tabToMoveToFront);
    clone.splice(index, 1);
  } else {
    clone.pop();
  }
  clone = [...[tabToMoveToFront], ...clone];
  return clone;
}
